import React, { useMemo, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Lot 711 — « Relevé PDF » d'un associé : choix du mois (depuis son entrée, 24 mois max) puis téléchargement de
// GET /admin/associates/{id}/statement.pdf?month=YYYY-MM (super admin, ou l'associé pour son propre relevé).
export const monthsSince = (since, max = 24) => {
  const out = [];
  const now = new Date();
  const start = since ? new Date(`${since}-01T00:00:00`) : new Date(now.getFullYear(), now.getMonth() - 11, 1);
  for (let i = 0; i < max; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    if (d < start) break;
    out.push({ key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`, label: d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }) });
  }
  return out.length ? out : [{ key: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`, label: now.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }) }];
};

export const AssociateStatementButton = ({ associateId, since, testId = "associate-statement" }) => {
  const months = useMemo(() => monthsSince(since), [since]);
  const [month, setMonth] = useState(months[0].key);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/admin/associates/${associateId}/statement.pdf?month=${month}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `yalola-releve-associe-${month}.pdf`;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch { toast.error("Relevé indisponible pour le moment"); }
    setBusy(false);
  };
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testId}>
      <select value={month} onChange={(e) => setMonth(e.target.value)} className="h-8 rounded-full border px-2 text-xs capitalize" style={{ borderColor: "var(--yalola-border)", background: "var(--yalola-surface)" }} data-testid={`${testId}-month`}>
        {months.map((m) => <option key={m.key} value={m.key} className="capitalize">{m.label}</option>)}
      </select>
      <Button size="sm" variant="outline" className="rounded-full" onClick={download} disabled={busy} data-testid={`${testId}-download`}>
        {busy ? <Loader2 size={13} className="animate-spin mr-1" /> : <FileText size={13} className="mr-1" />} Relevé PDF
      </Button>
    </span>
  );
};

export default AssociateStatementButton;
